import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import baseHelper from '../../helpers/BaseHelper';
import appConst from '../../config/const';
import Spinner from '../../components/Spinner';
import ConfirmModal from '../../components/ConfirmModal';
import CreateProDNS from './CreateProDNS';
import * as types from '../../redux/futures/tools/types';
import toolsActions from '../../redux/futures/tools/actions';
import _ from 'lodash';

class ProDNS extends React.Component {
    static propTypes = {
        currentUser: PropTypes.object,
        onCancel: PropTypes.func
    }

    constructor(props) {
        super(props);
        this.state = {
            file: null,
            selectedResource: null,
            dnsRecords: []
        };
    }

    componentDidMount() {
    }

    componentWillReceiveProps(nextProps) {

        // console.log(nextProps.tools.action, nextProps.tools.status, nextProps.tools.message);
        // Check if previous action was completed

        if (nextProps.tools.action == types.UPDATE_PRODNS) {
            if (nextProps.tools.status) {
                window.LadiUI.toastr('success', '', nextProps.tools.message);
                window.LadiUI.closeModalById('confirm-disable-prodns');
                window.LadiUI.closeModalById('confirm-active-prodns');
            } else {
                window.LadiUI.toastr('error', '', nextProps.tools.message);
            }
        }
        if (nextProps.tools.action == types.LIST_DISTRIBUTION
            || nextProps.tools.action == types.UPDATE_HTML_PRODNS
        ) {
            // Check which action was completed

            // Check if action was successful
            if (nextProps.tools.status) {
                window.LadiUI.toastr('success', '', nextProps.tools.message);

                // Close modals based on action type
                if (nextProps.tools.action === types.LIST_DISTRIBUTION) {
                    // console.log(nextProps);
                    this.setState({ dnsRecords: nextProps.tools.result });
                } else if (nextProps.tools.action === types.UPDATE_HTML_PRODNS) {
                    window.LadiUI.closeModalById('confirm-update-html-prodns');
                    this.setState({
                        selectedResource: null,
                        file: null
                    }, () => {
                        // Reset all file input elements
                        const fileInputs = document.querySelectorAll('input[type="file"]');
                        fileInputs.forEach(input => {
                            input.value = '';
                        });
                        const pathInputs = document.querySelectorAll('input[type="text"]');
                        pathInputs.forEach(input => {
                            input.value = '';
                        });
                    })
                }

                // Recall getAddonsList after successful action
                // this.props.listDistribution({});
            } else {
                // Show error message if action failed
                window.LadiUI.toastr('error', '', nextProps.tools.message);

                // Reset input on error for UPDATE_HTML_PRODNS action
                if (nextProps.tools.action === types.UPDATE_HTML_PRODNS) {
                    window.LadiUI.closeModalById('confirm-update-html-prodns');
                    this.setState({
                        selectedResource: null,
                        file: null
                    }, () => {
                        // Reset all file input elements
                        const fileInputs = document.querySelectorAll('input[type="file"]');
                        fileInputs.forEach(input => {
                            input.value = '';
                        });
                        const pathInputs = document.querySelectorAll('input[type="text"]');
                        pathInputs.forEach(input => {
                            input.value = '';
                        });
                    });
                }
            }
        }
    }
    activeProDNS = () => {
        const { selectedResource } = this.state;
        const jsonData = { "distribution_id": selectedResource.Id, "is_enabled": true }
        this.props.updateProDNS(jsonData);
    }
    disableProDNS = () => {
        const { selectedResource } = this.state;
        const jsonData = { "distribution_id": selectedResource.Id, "is_enabled": false }
        this.props.updateProDNS(jsonData);
    }
    submit = () => {

        // Validate
        let errors = [];
        const { selectedResource } = this.state;
        const jsonData = { "distribution_id": selectedResource.Id, "path": selectedResource.path || '', "domain": selectedResource.Alias[0] }

        const form = new FormData();
        form.append('jsonData', JSON.stringify(jsonData));
        if (this.state.file) {
            form.append('avatar', this.state.file, this.state.file.name);
        }
        // console.log(form);
        // console.log(' submit')
        this.props.updateHtmlProDNS(form);

        this.state.loading = true;
        this.state.classApply = this.state.classLoading;
    }


    handleFileUploadForRow = (record, event) => {
        // console.log('handleFileUploadForRow', record, event)
        // Get the path value from the corresponding input field
        const pathInput = document.getElementById(`path-${record.Id}`);
        const pathValue = pathInput ? pathInput.value : '';

        // Update record with path value
        const updatedRecord = {
            ...record,
            path: pathValue
        };

        this.setState({ selectedResource: updatedRecord, file: event.target.files[0] },
            () => {
                // console.log('show modal confirm-update-html-prodns')
                window.LadiUI.showModalById('confirm-update-html-prodns');
            }
        )
    }


    render() {
        const { selectedResource, dnsRecords } = this.state;
        const isLoadingDelete = this.props.tools.loading && this.props.tools.waitting == types.UPDATE_HTML_PRODNS;
        const isLoadingUpdate = this.props.tools.loading && this.props.tools.waitting == types.UPDATE_PRODNS;

        return (
            <div id="modal-pro-dns" className="ladiui-modal fade" tabIndex={-1} data-dismiss="modal-pro-dns" style={{ zIndex: '21' }}>
                <div className="ladiui-modal-content">
                    <div className="ladiui-modal-header">
                        <button type="button" className="ladiui-close-modal" data-dismiss="modal-pro-dns">
                            <i className="ladi-icon icon-e-remove" data-dismiss="modal-pro-dns" />
                        </button>
                        <h3>Pro DNS Management</h3>
                        <button className="ladiui button primary open-modal" modal="create-prodns">Tạo mới</button>

                    </div>
                    <div className="ladiui-modal-body">
                        <table className="ladiui table">
                            <thead>
                                <tr>
                                    {/* <th className="text-left">Id</th> */}
                                    <th className="text-left">Domain</th>
                                    <th className="text-left">CNAME</th>
                                    <th className="text-left">Path</th>
                                    <th className="text-left">Thao tác</th>
                                </tr>
                            </thead>
                            <tbody>
                                {dnsRecords.map((record, index) => (
                                    <tr key={index}>
                                        {/* <td>{record.Id}</td> */}
                                        <td>
                                            {Array.isArray(record.Alias) ? record.Alias.join(', ') : record.Alias}
                                        </td>
                                        <td>
                                            {record.DomainName}
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                id={`path-${record.Id}`}
                                                className="ladiui input"
                                                placeholder="Enter path..."
                                                style={{ width: '100%', fontSize: '12px' }}
                                            />
                                        </td>
                                        <td>
                                            {record.Status === appConst.PRODNS_CONFIG.DISTRIBUTION_STATUS.Deployed && record.Enabled &&
                                                <div style={{ display: 'inline-flex', justifyContent: 'space-between' }}>
                                                    <div className="action-item" style={{ marginRight: '10px' }}>
                                                        <input
                                                            type="file"
                                                            accept=".html"
                                                            onChange={(event) => { console.log('onChange', event); this.handleFileUploadForRow(record, event) }}
                                                            style={{ display: 'none' }}
                                                            id={`file-upload-${index}`}
                                                        />
                                                        <label
                                                            htmlFor={`file-upload-${index}`}
                                                            className="ladiui button small primary icon-c-add"
                                                            style={{ marginLeft: '5px', cursor: 'pointer', fontSize: '12px' }}
                                                        >
                                                            Upload HTML
                                                        </label>
                                                    </div>
                                                    <div className="action-item">
                                                        <button className="ladiui button danger open-modal" modal="confirm-disable-prodns" onClick={() => this.setState({ selectedResource: record })}>Tạm ngưng</button>
                                                    </div>
                                                </div>
                                            }
                                            {record.Status === appConst.PRODNS_CONFIG.DISTRIBUTION_STATUS.InProgress &&
                                                'Đang chờ xử lý'
                                            }
                                            {record.Status === appConst.PRODNS_CONFIG.DISTRIBUTION_STATUS.Deployed && !record.Enabled &&
                                                <button className="ladiui button primary open-modal" modal="confirm-active-prodns" onClick={() => this.setState({ selectedResource: record })}>Kích hoạt</button>
                                            }
                                        </td>
                                    </tr>
                                ))}
                                {dnsRecords.length === 0 && (
                                    <tr className="text-center">
                                        <td colSpan="4">Không có DNS records</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                        {this.props.tools.loading && <Spinner />}
                    </div>
                </div>


                <ConfirmModal
                    id="confirm-disable-prodns"
                    title="Tạm ngưng hoạt động ProDNS"
                    content={`Bạn đang tạm ngưng hoạt động domain ${selectedResource ? selectedResource.Alias[0] : ''} , bạn có chắc chắn thực hiện?`}
                    cancelText="Huỷ bỏ"
                    okText="Đồng ý"
                    onOk={() => this.disableProDNS()}
                    isLoading={isLoadingUpdate}
                />

                <ConfirmModal
                    id="confirm-active-prodns"
                    title="Kích hoạt ProDNS"
                    content={`Bạn đang kích hoạt domain ${selectedResource ? selectedResource.Alias[0] : ''} , bạn có chắc chắn thực hiện?`}
                    cancelText="Huỷ bỏ"
                    okText="Đồng ý"
                    onOk={() => this.activeProDNS()}
                    isLoading={isLoadingUpdate}
                />

                <ConfirmModal
                    id="confirm-update-html-prodns"
                    title="Cập nhật HTML ProDNS"
                    content={`Bạn đang update file ${this.state.file ? this.state.file.name : ''} cho domain ${selectedResource ? selectedResource.Alias[0] : ''} và đường dẫn ${selectedResource ? selectedResource.path : ''}, bạn có chắc chắn thực hiện?`}
                    cancelText="Huỷ bỏ"
                    okText="Đồng ý"
                    onOk={() => this.submit()}
                    isLoading={isLoadingDelete}
                />

                <CreateProDNS />
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    tools: { ...state.tool }

});

const mapDispatchToProps = (dispatch) => ({
    listDistribution: (data) => dispatch(toolsActions.listDistribution(data)),
    updateHtmlProDNS: (data) => dispatch(toolsActions.updateHtmlProDNS(data)),
    updateProDNS: (data) => dispatch(toolsActions.updateProDNS(data))
});

export default connect(mapStateToProps, mapDispatchToProps)(ProDNS); 